module.exports = __webpack_public_path__ + "static/media/WCCD_Horizontal_White.2a4a199f.png";